<template>
    <div>
        <slot name="fetching" v-if="isModeFetching">
            <div class="text-center"><i class="fas fa-circle-notch fa-spin"></i></div>
        </slot>
        <slot name="no-content" v-if="isModeNoContent">
            <div class="text-center">No Content</div>
        </slot>
        <slot name="fetching" v-if="isModeError">
            <div class="text-center">Server Error</div>
        </slot>
        <div v-if="isModeDisplay" v-html="content"></div>
    </div>
</template>

<script>
    const modes = {
        fetching: 'fetching',
        noContent: 'noContent',
        display: 'display',
        error: 'error',
    };

    export default {
        props: {
            url: String,
            method: {
                type: String,
                default: 'get'
            },
        },

        computed: {
            /**
             * @return {Boolean}
             */
            isModeFetching() {
                return this.mode === modes.fetching;
            },

            /**
             * @return {Boolean}
             */
            isModeDisplay() {
                return this.mode === modes.display;
            },

            /**
             * @return {Boolean}
             */
            isModeError() {
                return this.mode === modes.error;
            },

            /**
             * @return {Boolean}
             */
            isModeNoContent() {
                return this.mode === modes.noContent;
            },
        },

        data: function () {
            return {
                mode: modes.fetching,
                content: '',
            };
        },

        methods: {
            getContent() {
                if (!this.url) {
                    return this.mode = modes.noContent;
                }
                axios.request({method: this.method, url: this.url})
                    .then(this.onSuccess)
                    .catch(this.onError);
            },

            onSuccess({data}) {
                this.mode = modes.display;
                this.content = _.get(data, 'data', '');
            },

            onError({response}) {
                this.mode = modes.error;
            },
        },

        mounted() {
            this.getContent();
        }
    }
</script>

<style scoped>

</style>
